import React, { FC } from 'react'
import Alert from '@material-ui/lab/Alert'
import Collapse from '@material-ui/core/Collapse'
import PriorityHighSharpIcon from '@material-ui/icons/PriorityHighSharp'
import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => {
  return {
    alert: {
      backgroundColor: theme.palette.rich.red,
      color: theme.palette.common.white,
    },
    alertContent: {
      color: theme.palette.common.white,
      padding: theme.spacing(0),
    },
    alertclick: {
      padding: theme.spacing(0),
      margin: theme.spacing(0, 1, 0, 0),
    },
  }
})

interface ErrorAlertProps {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  message: any
}

const ErrorAlert: FC<ErrorAlertProps> = (props) => {
  const { open, message } = props
  const classes = useStyles()
  return (
    <Collapse in={open}>
      <Alert
        icon={
          <PriorityHighSharpIcon
            fontSize="inherit"
            className={classes.alertContent}
          />
        }
        className={classes.alert}
      >
        {message}
      </Alert>
    </Collapse>
  )
}

export default ErrorAlert
